/**
 * Which words of the current lyrics line have been said, from how much reply audio has played: the
 * backend sends no word timings, so the pace is the reply's own (its length over its spoken characters)
 * as soon as the backend says how long it is, and until then the pace of the last reply.
 */

/** The pace before any reply has been measured (Italian TTS at speed 1.25, ms per spoken character). */
export const DEFAULT_MS_PER_CHAR = 55;

/** Emoji are shown, not said. */
const UNSPOKEN = /\p{Extended_Pictographic}|️/gu;

export function spokenLength(text: string): number {
  return text.replace(UNSPOKEN, '').length;
}

/** How many tokens (words and the spaces between) have been said after `playedMs`. */
export function litWords(tokens: string[], playedMs: number, msPerChar: number): number {
  let chars = 0;
  for (let i = 0; i < tokens.length; i++) {
    chars += spokenLength(tokens[i]!);
    if (chars * msPerChar > playedMs) return i;
  }
  return tokens.length;
}

/** The pace of the voice, learned from each reply whose length is known and kept for the next one. */
export function createPace(start = DEFAULT_MS_PER_CHAR) {
  let learned = start;
  return (text: string, totalMs: number | null): number => {
    const chars = spokenLength(text);
    if (totalMs !== null && totalMs > 0 && chars > 0) learned = totalMs / chars;
    return learned;
  };
}
